import axiosInstance from '@/utils/axiosInstance';
import { showAlert } from '@/components/common/toastify/ToastContainer';
import { handleApiError } from '@/lib/handleApiError';

export const getMinMaxSettings = async (
  page,
  size,
  search,
  sortField,
  sortDirection,
) => {
  const res = await axiosInstance.get(
    `/SmartProAPI/api/min-max-setting?page=${page}&size=${size}&searchTerm=${search}&sortBy=${sortField}&sortDir=${sortDirection}`,
  );
  if (res.status === 204) {
    return ['No Data Found'];
  }
  return res.data;
};

export const postMinMaxSettings = async (data) => {
  try {
    const res = await axiosInstance.post(
      '/SmartProAPI/api/min-max-setting',
      data,
    );
    showAlert('success', res.data);
  } catch (error) {
    throw error;
  }
};

export const putMinMaxSettings = async (id, data) => {
  try {
    const res = await axiosInstance.put(
      `/SmartProAPI/api/min-max-setting/${id}`,
      data,
    );
    showAlert('success', res.data);
  } catch (error) {
    throw error;
  }
};

export const deleteMinMaxSettings = async (id) => {
  try {
    const res = await axiosInstance.delete(
      `/SmartProAPI/api/min-max-setting/${id}`,
    );
  } catch (error) {
    throw error;
  }
};

export const getWhrehouseList = async () => {
  try {
    const res = await axiosInstance.get('/SmartProAPI/api/warehouse');
    return res.data;
  } catch (error) {
    handleApiError('error', error.response?.data, error?.response?.status);
    throw error;
  }
};

export const getAbcClassList = async () => {
  try {
    const res = await axiosInstance.get(
      '/SmartProAPI/api/products/abc-class-list',
    );
    return res.data;
  } catch (error) {
    handleApiError('error', error.response?.data, error?.response?.status);
    throw error;
  }
};

export const getMinMaxReportAPI = async (data) => {
  try {
    const response = await axiosInstance.post(
      '/SmartProAPI/api/min-max-maintenance-report/get-report',
      data,
      {
        responseType: 'blob', // Important for downloading files
      },
    );
    if (response.status == '204') {
      showAlert('info', 'No data found to download.');
      return;
    }
    return response.data;
  } catch (error) {
    handleApiError('error', error.response?.data, error?.response?.status);
    throw error;
  }
};

export const importForPronto = async (data) => {
  try {
    const response = await axiosInstance.post(
      //api/min-max-maintenance-report/import-for-pronto
      '/SmartProAPI/api/min-max-maintenance-report/import-for-pronto',
      data,
      {
        responseType: 'blob', // Important for downloading files
      },
    );
    if (response.status == '204') {
      showAlert('info', 'No data found to download.');
      return;
    }
    return response.data;
  } catch (error) {
    handleApiError('error', error.response?.data, error?.response?.status);
    throw error;
  }
};
